import { render, staticRenderFns } from "./AccrualsColumnTagsInput.vue?vue&type=template&id=028c8708&scoped=true"
import script from "./AccrualsColumnTagsInput.vue?vue&type=script&lang=js"
export * from "./AccrualsColumnTagsInput.vue?vue&type=script&lang=js"
import style0 from "./AccrualsColumnTagsInput.scss?vue&type=style&index=0&id=028c8708&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c8708",
  null
  
)

export default component.exports